export default 'userOnboarding'
